import { AfterContentInit, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators, AbstractControl } from '@angular/forms';
import { BusinessModel, LocationModel, ResellerModel } from '@models/index';
import { phoneNumberMask, zipCodeMask, emptyLocationModel, emptyResellerModel } from '../../../core/utilities/data-utils';
import { AdminFacadeService } from '@services/admin-facade.service';
import { Subscription } from 'rxjs';
import Swal from 'sweetalert2';
import { NgxPermissionsService } from 'ngx-permissions';
import { environment } from '@environments/environment';

@Component({
  selector: 'app-business-form',
  templateUrl: './business-form.component.html',
  styleUrls: ['./business-form.component.sass']
})
export class BusinessFormComponent implements OnInit, AfterContentInit {

  @Output() createBusiness = new EventEmitter<BusinessModel>();
  @Output() createLocation = new EventEmitter<LocationModel>();
  @Output() editBusiness = new EventEmitter<BusinessModel>();
  @Output() cancel = new EventEmitter();
  @Output() addBusinessWithLocation = new EventEmitter();
  @Input() business: BusinessModel;
  @Input() create: boolean;

  _subs: Subscription = new Subscription();
  businessForm: FormGroup;
  locationForm: FormGroup;
  location: LocationModel;
  phoneNumberMask = phoneNumberMask;
  zipCodeMask = zipCodeMask;
  regions = ['north-america', 'carribean']
  mapLocation = { lat: 0, lng: 0 }
  formLocation: LocationModel = emptyLocationModel();
  showLocationForm = false;
  initialImage?: string = null;

  GMRResellerId = environment.freeTrialResellerId
  permissions: any;
  minDateEndTrial = new Date(this.window.moment().unix()*1000)

  selectedReseller$ = this.adminFacadeService.getSelectedReseller$();
  resellerById$ = this.adminFacadeService.getResellerById$();
  selectedReseller: ResellerModel = emptyResellerModel();
  trialVersion: boolean = false

  constructor(
    private fb: FormBuilder,
    private adminFacadeService: AdminFacadeService,
    private permissionsService: NgxPermissionsService,
    private window: Window,
  ) {}

  ngOnInit() { }

  ngAfterContentInit() {
    
    this.permissions = this.permissionsService.getPermissions()

    this._subs.add(
      this.selectedReseller$.subscribe(
        reseller =>
          this.adminFacadeService.getResellerById(reseller.id)
      )
    );

    this._subs.add(
      this.resellerById$.subscribe(
        reseller =>
          this.selectedReseller = reseller
      )
    );

    this.businessForm = this.fb.group({
      name: [this.business.name, [Validators.required, this.ValidateName]],
      trialMode: [this.business.trialMode],
      trialStartDate: [this.create ? new Date().toLocaleDateString() : new Date(this.business.trialStartDate).toLocaleDateString()],
      trialEndDate: [this.create ? new Date(this.window.moment().add(14,'days').unix() * 1000) : new Date(this.business.trialEndDate)]
    });

    console.log('initialImage:', this.business.logo);
    this.initialImage = this.business.logo;

    this.formChanged();
  }

  formChanged(): void {
    this.businessForm.valueChanges.subscribe(
      _val => {
        if (!this.businessForm.valid) this.showLocationForm = false;
      }
    )
  }

  onSubmit() {
    const business = {
      ...this.business,
      ...this.businessForm.value,
      trialStartDate : this.businessForm.get('trialMode').value ? 
        new Date(this.businessForm.get('trialStartDate').value).getTime() : -1,
      trialEndDate : this.businessForm.get('trialMode').value ? 
        this.businessForm.get('trialEndDate').value.getTime() : -1
    }
    !this.create ? this.editBusiness.emit(business)
      : this.createBusiness.emit(business);
  }

  updateTrialMode() {
    this.businessForm.patchValue({
      trialMode: !this.businessForm.value.trialMode
    })
  }

  convertTrial() {
    Swal.fire({
      title: 'Convert to non trial business?',
      text: 'If you convert this business to a non trial one then you cannot reverse it to a trial one',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'OK, Convert',
    }).then(result => {
      if (result.value) {
        this.businessForm.patchValue({
          trialMode: false
        })
      }
    })
  }

  createBusinessWithLocation(location: LocationModel) {
    const business = {
      ...this.business,
      ...this.businessForm.value,
      trialStartDate : this.businessForm.get('trialMode').value ? 
        new Date(this.businessForm.get('trialStartDate').value).getTime() : -1,
      trialEndDate : this.businessForm.get('trialMode').value ? 
        this.businessForm.get('trialEndDate').value.getTime() : -1
    }

    const data = {
      ...{},
      business: business,
      location: location
    }
    this.addBusinessWithLocation.emit(data)
  }

  imageChanged(image: string): void {
    this.business = { ...this.business, logo: image ? image : '' };
  }

  ValidateName(control: AbstractControl) {
    if (control.value && control.value.trim().length) {
      return null;
    }
    return { invalid: true };
  }
  
  noAvailableLicenses() {
    Swal.fire({
      title: 'No Available Licenses',
      html: 'You have no available licenses to add a new location. Please <a href="/reseller/reseller-profile">add a license to your account </a> or contact us for assistance',
      icon: 'warning',
      showCancelButton: false,
      confirmButtonText: 'OK'
    })
  }

  ngOnDestroy(): void {
    if (this._subs) this._subs.unsubscribe()
  }

}
